import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5752a99b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "attachments-container" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Calendar Attachments", -1))
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading attachments...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "error-message"
}
const _hoisted_8 = {
  key: 2,
  class: "no-data"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No attachments found for this calendar.", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 3,
  class: "attachments-list"
}
const _hoisted_12 = { class: "attachment-icon" }
const _hoisted_13 = { class: "attachment-details" }
const _hoisted_14 = {
  key: 0,
  class: "attachment-description"
}
const _hoisted_15 = {
  key: 1,
  class: "attachment-years"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "attachment-meta" }
const _hoisted_19 = { class: "file-size" }
const _hoisted_20 = { class: "file-type" }
const _hoisted_21 = { class: "upload-date" }
const _hoisted_22 = {
  key: 0,
  class: "attachment-preview"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "attachment-actions" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 4,
  class: "modal-overlay"
}
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Upload Attachment", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "file" }, "File *", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-help" }, "Supported formats: PDF, Images, Documents", -1))
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Display Name", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "form-help" }, "Leave blank to use the original filename", -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_39 = { class: "form-row" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startYear" }, "Start Year", -1))
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endYear" }, "End Year", -1))
const _hoisted_44 = { class: "modal-actions" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = {
  key: 5,
  class: "modal-overlay"
}
const _hoisted_49 = { class: "modal-content" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Confirm Delete", -1))
const _hoisted_51 = { class: "modal-actions" }
const _hoisted_52 = {
  key: 6,
  class: "modal-overlay"
}
const _hoisted_53 = { class: "modal-content preview-modal" }
const _hoisted_54 = { class: "preview-header" }
const _hoisted_55 = { class: "preview-content" }
const _hoisted_56 = ["src"]
const _hoisted_57 = ["src", "alt"]
const _hoisted_58 = {
  key: 2,
  class: "document-preview"
}
const _hoisted_59 = { class: "document-icon" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Document preview is not available. Please download to view.", -1))
const _hoisted_61 = {
  key: 3,
  class: "other-preview"
}
const _hoisted_62 = { class: "file-icon" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Preview is not available for this file type. Please download to view. ", -1))
const _hoisted_64 = { class: "preview-footer" }

import { ref, onMounted } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { API_URL } from "../config";

enum AttachmentType {
  PDF = "pdf",
  IMAGE = "image",
  DOCUMENT = "document",
  OTHER = "other",
}

interface CalendarAttachment {
  id: number;
  name?: string;
  startYear?: number;
  endYear?: number;
  filename: string;
  originalFilename: string;
  type: AttachmentType;
  mimeType: string;
  size: number;
  description?: string;
  createdAt: string;
  updatedAt: string;
  previewUrl?: string;
}

interface UploadForm {
  name: string;
  description: string;
  startYear: string;
  endYear: string;
  file: File | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarAttachments',
  props: {
    calendarId: {}
  },
  emits: ["attachment-deleted"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

// State
const attachments = ref<CalendarAttachment[]>([]);
const loading = ref(true);
const error = ref("");
const showDeleteModal = ref(false);
const attachmentToDelete = ref<CalendarAttachment | null>(null);
const showUploadModal = ref(false);
const isUploading = ref(false);
const fileInput = ref<HTMLInputElement | null>(null);

// Upload form state
const uploadForm = ref<UploadForm>({
  name: "",
  description: "",
  startYear: "",
  endYear: "",
  file: null,
});

// Add new state for preview modal
const showPreviewModal = ref(false);
const selectedAttachment = ref<CalendarAttachment | null>(null);

// Add new state for attachment preview URLs
const attachmentPreviewUrls = ref<{ [key: number]: string }>({});

// Fetch attachments
const fetchAttachments = async () => {
  loading.value = true;
  try {
    const response = await axios.get(
      `${API_URL}/calendar/${props.calendarId}/attachments`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    attachments.value = response.data;
  } catch (err) {
    error.value =
      err instanceof Error ? err.message : "Failed to fetch attachments";
    console.error("Error fetching attachments:", err);
  } finally {
    loading.value = false;
  }
};

// Format file size
const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

// Format date
const formatDate = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Get attachment URL for images and previews
const getAttachmentUrl = async (attachmentId: number): Promise<string> => {
  // Return cached URL if available
  if (attachmentPreviewUrls.value[attachmentId]) {
    return attachmentPreviewUrls.value[attachmentId];
  }

  try {
    const response = await axios.get(
      `${API_URL}/attachments/${attachmentId}/download`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        responseType: "blob",
      }
    );

    // Create a blob URL from the response data
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });
    const url = URL.createObjectURL(blob);

    // Cache the URL
    attachmentPreviewUrls.value[attachmentId] = url;
    return url;
  } catch (error) {
    console.error("Error getting attachment URL:", error);
    return "";
  }
};

// Download attachment
const downloadAttachment = (attachmentId: number) => {
  window.open(`${API_URL}/attachments/${attachmentId}/download`, "_blank");
};

// Confirm delete
const confirmDelete = (attachment: CalendarAttachment) => {
  attachmentToDelete.value = attachment;
  showDeleteModal.value = true;
};

// Delete attachment
const deleteAttachment = async () => {
  if (!attachmentToDelete.value) return;

  try {
    await axios.delete(
      `${API_URL}/attachments/${attachmentToDelete.value.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    // Remove from local list
    const attachmentId = attachmentToDelete.value.id;
    attachments.value = attachments.value.filter((a) => a.id !== attachmentId);

    // Close modal
    showDeleteModal.value = false;
    attachmentToDelete.value = null;

    // Emit event
    emit("attachment-deleted");
  } catch (err) {
    error.value =
      err instanceof Error ? err.message : "Failed to delete attachment";
    console.error("Error deleting attachment:", err);
  }
};

// Upload modal functions
const openUploadModal = () => {
  showUploadModal.value = true;
  uploadForm.value = {
    name: "",
    description: "",
    startYear: "",
    endYear: "",
    file: null,
  };
};

const closeUploadModal = () => {
  showUploadModal.value = false;
  if (fileInput.value) {
    fileInput.value.value = "";
  }
};

const handleFileSelect = (event: Event) => {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files[0]) {
    uploadForm.value.file = input.files[0];
  }
};

const handleUpload = async () => {
  if (!uploadForm.value.file) {
    error.value = "Please select a file to upload";
    return;
  }

  isUploading.value = true;
  error.value = "";

  try {
    const formData = new FormData();
    formData.append("file", uploadForm.value.file);
    formData.append("name", uploadForm.value.name);
    formData.append("description", uploadForm.value.description);
    if (uploadForm.value.startYear) {
      formData.append("startYear", uploadForm.value.startYear);
    }
    if (uploadForm.value.endYear) {
      formData.append("endYear", uploadForm.value.endYear);
    }

    await axios.post(
      `${API_URL}/calendar/${props.calendarId}/attachments`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Refresh attachments list
    await fetchAttachments();
    closeUploadModal();
  } catch (err) {
    error.value =
      err instanceof Error ? err.message : "Failed to upload attachment";
    console.error("Error uploading attachment:", err);
  } finally {
    isUploading.value = false;
  }
};

// Refresh attachments
const refreshAttachments = () => {
  fetchAttachments();
};

// Expose methods to parent component
__expose({
  refreshAttachments,
});

// Lifecycle hooks
onMounted(() => {
  fetchAttachments();
});

// Update the preview functions
const openPreview = async (attachment: CalendarAttachment) => {
  try {
    const url = await getAttachmentUrl(attachment.id);
    if (url) {
      selectedAttachment.value = { ...attachment, previewUrl: url };
      showPreviewModal.value = true;
    }
  } catch (error) {
    console.error("Error opening preview:", error);
  }
};

const closePreview = () => {
  if (selectedAttachment.value?.previewUrl) {
    URL.revokeObjectURL(selectedAttachment.value.previewUrl);
  }
  showPreviewModal.value = false;
  selectedAttachment.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn-upload",
        onClick: openUploadModal
      }, [
        _createVNode(_unref(FontAwesomeIcon), { icon: "upload" }),
        _createTextVNode(" Upload Attachment ")
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(error.value), 1))
        : (attachments.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (attachment) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: attachment.id,
                  class: "attachment-card"
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    (attachment.type === 'pdf')
                      ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                          key: 0,
                          icon: "file-pdf",
                          size: "2x"
                        }))
                      : (attachment.type === 'document')
                        ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                            key: 1,
                            icon: "file-word",
                            size: "2x"
                          }))
                        : (attachment.type === 'image')
                          ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                              key: 2,
                              icon: "image",
                              size: "2x"
                            }))
                          : (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
                              key: 3,
                              icon: "file",
                              size: "2x"
                            }))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h4", null, _toDisplayString(attachment.name || attachment.originalFilename), 1),
                    (attachment.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(attachment.description), 1))
                      : _createCommentVNode("", true),
                    (attachment.startYear || attachment.endYear)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          (attachment.startYear)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, "From: " + _toDisplayString(attachment.startYear), 1))
                            : _createCommentVNode("", true),
                          (attachment.endYear)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "To: " + _toDisplayString(attachment.endYear), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(formatFileSize(attachment.size)), 1),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(attachment.type), 1),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(formatDate(attachment.createdAt)), 1)
                    ])
                  ]),
                  (attachment.type === 'image')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("img", {
                          src: attachmentPreviewUrls.value[attachment.id] || '',
                          alt: "Attachment preview"
                        }, null, 8, _hoisted_23)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      class: "btn-preview",
                      onClick: ($event: any) => (openPreview(attachment))
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "eye" }),
                      _createTextVNode(" Preview ")
                    ], 8, _hoisted_25),
                    _createElementVNode("button", {
                      class: "btn-download",
                      onClick: ($event: any) => (downloadAttachment(attachment.id))
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "download" }),
                      _createTextVNode(" Download ")
                    ], 8, _hoisted_26),
                    _createElementVNode("button", {
                      class: "btn-delete",
                      onClick: ($event: any) => (confirmDelete(attachment))
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "trash" }),
                      _createTextVNode(" Delete ")
                    ], 8, _hoisted_27)
                  ])
                ]))
              }), 128))
            ])),
    (showUploadModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleUpload, ["prevent"]),
              class: "upload-form"
            }, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("input", {
                  type: "file",
                  id: "file",
                  ref_key: "fileInput",
                  ref: fileInput,
                  onChange: handleFileSelect,
                  required: ""
                }, null, 544),
                _hoisted_33
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploadForm.value.name) = $event)),
                  placeholder: "Enter a display name for the attachment"
                }, null, 512), [
                  [_vModelText, uploadForm.value.name]
                ]),
                _hoisted_36
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("textarea", {
                  id: "description",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((uploadForm.value.description) = $event)),
                  placeholder: "Enter a description for the attachment",
                  rows: "3"
                }, null, 512), [
                  [_vModelText, uploadForm.value.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "startYear",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((uploadForm.value.startYear) = $event)),
                    placeholder: "e.g., 2024",
                    min: "2000",
                    max: "2100"
                  }, null, 512), [
                    [_vModelText, uploadForm.value.startYear]
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    id: "endYear",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((uploadForm.value.endYear) = $event)),
                    placeholder: "e.g., 2025",
                    min: "2000",
                    max: "2100"
                  }, null, 512), [
                    [_vModelText, uploadForm.value.endYear]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-cancel",
                  onClick: closeUploadModal
                }, " Cancel "),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn-submit",
                  disabled: isUploading.value
                }, [
                  (isUploading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, "Uploading..."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_47, "Upload"))
                ], 8, _hoisted_45)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (showDeleteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _createElementVNode("p", null, " Are you sure you want to delete the attachment \"" + _toDisplayString(attachmentToDelete.value?.originalFilename) + "\"? ", 1),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showDeleteModal.value = false))
              }, " Cancel "),
              _createElementVNode("button", {
                class: "btn-confirm-delete",
                onClick: deleteAttachment
              }, " Delete ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showPreviewModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("h3", null, _toDisplayString(selectedAttachment.value?.name || selectedAttachment.value?.originalFilename), 1),
              _createElementVNode("button", {
                class: "btn-close",
                onClick: closePreview
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: "times" })
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              (selectedAttachment.value?.type === 'pdf')
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    src: selectedAttachment.value?.previewUrl,
                    class: "pdf-preview"
                  }, null, 8, _hoisted_56))
                : (selectedAttachment.value?.type === 'image')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: selectedAttachment.value?.previewUrl,
                      alt: selectedAttachment.value?.name,
                      class: "image-preview"
                    }, null, 8, _hoisted_57))
                  : (selectedAttachment.value?.type === 'document')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_unref(FontAwesomeIcon), {
                            icon: "file-word",
                            size: "3x"
                          })
                        ]),
                        _hoisted_60
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_unref(FontAwesomeIcon), {
                            icon: "file",
                            size: "3x"
                          })
                        ]),
                        _hoisted_63
                      ]))
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("button", {
                class: "btn-download",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (downloadAttachment(selectedAttachment.value?.id)))
              }, [
                _createVNode(_unref(FontAwesomeIcon), { icon: "download" }),
                _createTextVNode(" Download ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})